import React, { memo } from 'react';
import { connect } from 'dva';
import styles from './index.less';
import classnames from 'classnames';
import { ICinameItem } from '@/interface/index';
import { toPrice } from '@/utils/price';
import DfPrice from '../dFPrice';
import { TLang } from '@/utils/lang';
function parseMi(x) {
  let d = x / 1000;
  if (d > 1 && d < 9999) {
    return `${d.toFixed(2)}km`;
  } else if (d > 9999 || d === 0) {
    return '';
  } {
    return `${x}m`;
  }
}
const CinemaItem = (props: ICinameItem): JSX.Element => {
  const { noBorder = false } = props;
  const getShowTimeText = (times: Array<string | number>) => {
    let timestr = TLang('近期场次', 'home', false, false, null)+'：' + times.join('  ');
    return timestr;
  };
  // console.log(props.feature)
  // console.log('props.isShowKM', props.isShowKM);
  return (
    <div
      className={`${styles.cinemaItemContainer} ${noBorder ? styles.noBorder : ''}`}
      onClick={() => props.onClick(props)}
    >
      <div className={styles.itemTop}>
        <div className={styles.name}>{props.name}</div>
        {//noShowTime
          props.lowPrice > 0 ? (
            <DfPrice
              price={props.lowPrice}
              cls={'lg'}
              textStyles={{ fontSize: '0.28rem', color: '#F44545', marginRight: '3px' }}
              showQi
            />
          ) : (
            <div className={styles.noShowTime}>{TLang('参考价:暂无', 'home', false, false, null)}</div>
          )}
      </div>
      <div className={styles.itemMiddle}>
        <div className={styles.address}>{props.address}</div>
        {props.isShowKM && <div className={styles.distance}>{parseMi(props.distance)}</div>}
      </div>
      {(props.features && props.features.length > 0 || props?.snackFeature || props?.lowPriceTag) ? (
        <div className={styles.itemBottom}>
          {props?.lowPriceTag && <span className={styles.discount}>{TLang('抢折扣', 'home', false, false, null)}</span>}
          {props?.snackFeature?.name && <span className={styles.discount}>{props?.snackFeature?.name || ''}</span>}
          {props.features && props.features.length > 0 && props.features.map((i, idx) => <span key={idx}>{i.name}</span>)}
        </div>
      ) : null}

      {props.showTime ? (
        <div className={styles.showTimeContainer}>
          {getShowTimeText(props.lastSessionsShowTime)}
        </div>
      ) : null}
    </div>
  );
};
export default memo(connect((state) => ({ ...state?.cinema }))(CinemaItem));
